module.exports = __webpack_public_path__ + "static/media/clean.4b13d1c0.svg";